import Cookies from 'js-cookie';

import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';
import Customer from 'coreClasses/customer/Customer';
import {EAnalyticsEventSource, EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

import CartInfoModel from './common/CartInfoModel';
import WishlistInfoModel from './common/WishlistInfoModel';
import UserInfoModel from './common/UserInfoModel';
import {IPdpProduct} from './common/IAnalytics';
import {getPageReferrer} from 'coreUtils/url';

/**
 * Represents PageViewEvent
 */
export default class PageViewEvent implements IAnalyticsEvent {
	public event: string;
	public page_type: string;
	public clean_url: string;
	public language: string;
	public zendesk_locale: string;
	public ecom_currency: string;
	public country: string;
	public personal_shopper_id: string;
	public user_info: UserInfoModel;
	public pdp_product: IPdpProduct;
	public cart_info: CartInfoModel;
	public wishlist_info: WishlistInfoModel;
	public eventReady: Promise<PageViewEvent>;
	public plp_category: any;
	public page_referrer: string;
	public is_landing: boolean;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		const customer: Customer = data.customer;
		const basket = data.basket;
		const currentLocale = data.currentLocale;
		const pageSpecificData = data.pageSpecificData;
		const pageType = EAnalyticsEventSource[EEventSource[data.pageType]];
		const pageViewCounter: number = data.pageViewCounter;

		this.event = EAnalyticsEventType.PAGE_VIEW;
		this.page_type = pageType || EAnalyticsEventSource.OTHER;
		this.clean_url = data.uri;
		this.language = currentLocale?.getLanguageCode();
		this.zendesk_locale = data.locale;
		this.ecom_currency = currentLocale?.getCurrencyCode();
		this.country = currentLocale?.getCountryCode();
		this.personal_shopper_id = Cookies.get('personalShopperUserId') || '';
		this.user_info = {...new UserInfoModel(customer)};
		this.cart_info = {...new CartInfoModel(basket)};
		this.plp_category = {
			product_category: pageType === EAnalyticsEventSource.PLP && pageSpecificData?.productCategory || undefined,
			product_sub_category: pageType === EAnalyticsEventSource.PLP && pageSpecificData?.productSubCategory || undefined,
			product_category_path: pageSpecificData?.categoryPath
		};
		this.page_referrer = getPageReferrer(pageViewCounter === 0);
		this.pdp_product = {
			product_name: pageSpecificData?.productName,
			product_id: pageSpecificData?.productSku,
			product_price: pageSpecificData?.productPrice?.value || 0,
			product_category: pageType === EAnalyticsEventSource.PDP && pageSpecificData?.productCategory || undefined,
			product_sub_category: pageType === EAnalyticsEventSource.PDP && pageSpecificData?.productSubCategory || undefined,
			product_type: pageSpecificData?.productType,
		};

		this.eventReady = new Promise((resolve, reject) => {
			if (this.page_type === EAnalyticsEventSource.PDP && !pageSpecificData?.productName) {
				reject();
			}

			this.wishlist_info = new WishlistInfoModel(data.wishlist, data.wishlistProducts);

			resolve(this);
		});
		this.is_landing = pageViewCounter === 0;
	}
}
